// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"bd856dbe","367":"9bc57e6e","421":"00a1a727","428":"6edcc254","644":"b44ded2d","647":"547deb0d","667":"b0f07dce","768":"3444855f","829":"69dbd7c5","856":"f5e5ea76","956":"cc776a84","988":"d15f4c95"}[chunkId] + ".chunk.js";
};